module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-page index-page"
  }, [(!_vm.isComp && !_vm.onMobile) ? _c('discover-nav', {
    attrs: {
      "pageName": "video",
      "searchShow": this.$store.state.app.sideBarMini
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page",
    class: {
      isComp: _vm.isComp
    }
  }, [_c('div', {
    staticClass: "page-content"
  }, [(_vm.viewAllVideos) ? _c('v-container', {
    staticClass: "px-0"
  }, [_c('div', {
    staticClass: "mx-5"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      key: index
    }, [_c('label', {
      class: (tab.title === _vm.selectedVideoCategoryName) ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.displayAllVideos(tab.title)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [_c('v-btn', {
    staticClass: "btn-genre-selector",
    attrs: {
      "dark": "",
      "rounded": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCategories: All\n\t\t\t\t\t\t\t\t")])], 1)], 2)])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "video-trending-page",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(!_vm.hideOtherVideos) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "id": "new-video-album-container"
    }
  }, _vm._l((_vm.videos), function(video) {
    return _c('v-flex', {
      key: video.name,
      staticClass: "video-container",
      class: [!_vm.isComp ? 'video-container top-3 xs12 sm3 mb-5 custom-lg5' : 'pl-0 xs4', {
        side_fullwidth: _vm.onMobile
      }]
    }, [_c('video-box', {
      staticClass: "_sliced-top",
      attrs: {
        "hoverOverlay": false,
        "item": video
      }
    })], 1)
  })) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "text-xs-center"
  }, [(_vm.isPageReady) ? _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pagination.current_page < _vm.pagination.total_pages),
      expression: "pagination.current_page < pagination.total_pages"
    }],
    staticClass: "loadmore-btn",
    nativeOn: {
      "click": function($event) {
        _vm.loadMore()
      }
    }
  }, [_vm._v("Load More")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard1),
      callback: function($$v) {
        _vm.show_modalCard1 = $$v
      },
      expression: "show_modalCard1"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.selectedVideo.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.selectedVideo.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tCreate account\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_auto dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard2),
      callback: function($$v) {
        _vm.show_modalCard2 = $$v
      },
      expression: "show_modalCard2"
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: (("background-image: url(" + _vm.bgDemoImg + ")"))
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(" " + _vm._s(this.selectedVideo.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-center font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t")])])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard3),
      callback: function($$v) {
        _vm.show_modalCard3 = $$v
      },
      expression: "show_modalCard3"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.selectedVideo.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.selectedVideo.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCreate account\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mute-icon.svg"),
      "width": "17px"
    }
  })])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "dialog-w_50 dialog-no_shadow"
    },
    model: {
      value: (_vm.show_modalCard4),
      callback: function($$v) {
        _vm.show_modalCard4 = $$v
      },
      expression: "show_modalCard4"
    }
  }, [_c('div', {
    staticClass: "modal-card-main"
  }, [_c('div', {
    staticClass: "modal-card-split"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/nav_logo_white.png"),
      "width": "135px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-img"
  }, [_c('div', {
    staticClass: "modal-card-img-inner",
    style: ({
      'background-image': 'url(' + this.selectedVideo.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-box"
  }, [_c('p', [_vm._v("Sign up to experience")]), _vm._v(" "), _c('div', {
    staticClass: "user-div"
  }, [_c('p', {
    staticClass: "user-text"
  }, [_vm._v(_vm._s(this.selectedVideo.user.username))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/check-white.svg"),
      "width": "15px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "font-inter"
  }, [_c('p', [_vm._v("Get full access. "), _c('b', [_vm._v("50%")]), _vm._v(" of your subscription is shared with creators you stream most. See who you support!")])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('button', {
    staticClass: "modal-button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tStart 30 day free trial\n\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-title-img",
    style: (("background-image: url(" + _vm.videoLoading + ")"))
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "loop": "",
      "id": "bgvid"
    }
  }, [(_vm.spotlightVideoSource) ? _c('source', {
    attrs: {
      "src": ("https://stream.mux.com/" + _vm.spotlightVideoSource + "/low.mp4"),
      "type": "video/mp4"
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "volume-button"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mute-icon.svg"),
      "width": "17px"
    }
  })])])])])], 1) : _c('div', {
    staticClass: "page-loader"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/loader.gif"),
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b6de363","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/index.vue
// module id = 1761
// module chunks = 180